import { useEventBus } from '@/event-bus'
import i18n from '@/i18n/i18n'
import { ProductPriceService } from '@/services/admin/ProductPriceService'
import { build_query, errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

const { eventEmitterTs } = useEventBus()

export const namespaced = true

export const allowedFilters = [
  'retailer_id',
  'product_id',
  'brand_id',
  'retailer.address.city_id',
  'retailer.address.county_id',
  'created_between',
  'in_stock',
  'trade_type'
]
export const allowedIncludes = ['retailer', 'product', 'brand']
export const allowedSorts = '-created_at'

export const state = {
  prices: null,
  price: {},
  meta: null
}

export const mutations = {
  SET_RETAILER_PRODUCT_PRICES(state, prices) {
    state.prices = prices.data
    state.meta = prices.meta
  },
  SET_RETAILER_PRODUCT_PRICE(state, price) {
    state.price = price
  }
}

export const actions = {
  getRetailerProductPrices({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts)

    return new Promise((resolve, reject) => {
      let blacklistService = new ProductPriceService(newQuery)
      blacklistService
        .getRetailerProductPrices()
        .then(response => {
          commit('SET_RETAILER_PRODUCT_PRICES', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.product_price.get_retailer_product_prices_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  exportProductPrices({ dispatch }, query) {
    let newQuery = build_query(query, allowedFilters)

    return new Promise(reject => {
      ProductPriceService.exportProductPrices(newQuery)
        .then(() => {
          const notification = {
            type: 'info',
            message: t('store.admin.product_price.export_product_prices_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.product_price.export_product_prices_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  toggleImportProductPricesModal() {
    eventEmitterTs.emit('toggle-import-mobile-prices-modal-event')
  },
  startImportMobilePricesProcess({ dispatch }, form) {
    return new Promise((resolve, reject) => {
      ProductPriceService.startImportMobilePricesProcess(form)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.product_price.start_import_mobile_prices_process_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.product_price.start_import_mobile_prices_process_error')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
